import { postBiz } from './bieForecastDataMartApi';

const rows = (json: any) => {
  const sd = json.sd || json.result?.sd || json.data?.sd;
  return Array.isArray(sd) ? sd : [];
};

export const generateForecastModel = (
  bac = 'BIEFC_2027_DETERMINANT_BASE',
  syr = '2026',
  tyr = '2027',
  cut = 6,
  grt = 0,
  cmo = 'RECONCILIATION',
) => postBiz({ s: 'bieforecastmodel', a: 'generate', bac, syr, tyr, cut, grt, cmo });

export const fetchForecastModelOutputs = async (
  bac = 'BIEFC_2027_DETERMINANT_BASE',
  syr = '2026',
  tyr = '2027',
) => rows(await postBiz({ s: 'bieforecastmodel', a: 'find', bac, syr, tyr }));

export const fetchForecastModelSummary = async (
  bac = 'BIEFC_2027_DETERMINANT_BASE',
  syr = '2026',
  tyr = '2027',
) => rows(await postBiz({ s: 'bieforecastmodel', a: 'summary', bac, syr, tyr }));

export const fetchForecastModelPayload = (
  bac = 'BIEFC_2027_DETERMINANT_BASE',
  scc = 'DET2027_BASE',
  syr = '2026',
  tyr = '2027',
) => postBiz({ s: 'bieforecastmodel', a: 'payload', bac, scc, syr, tyr });

export const commitForecastModelToSimulator = (
  bac = 'BIEFC_2027_DETERMINANT_BASE',
  scc = 'DET2027_BASE',
  syr = '2026',
  tyr = '2027',
  clr = true,
) => postBiz({ s: 'bieforecastmodel', a: 'commit', bac, scc, syr, tyr, clr });

export const fetchForecastModelCommitStatus = async (
  scc = 'DET2027_BASE',
  bac = 'BIEFC_2027_DETERMINANT_BASE',
) => rows(await postBiz({ s: 'bieforecastmodel', a: 'commitstatus', scc, bac }));
